import { render, staticRenderFns } from "./AthenaNav.vue?vue&type=template&id=6313f1bf&"
import script from "./AthenaNav.vue?vue&type=script&lang=js&"
export * from "./AthenaNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports